import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Button, Glyphicon } from 'react-bootstrap';
import IntlComponent from 'axway-react-intl';
import JoinsList from './JoinsList';
import ModelFieldList from './ModelFieldList';
import ModelInfo from './ModelInfo';

class ModelSummaryView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
	}

	render() {
		const { model, models } = this.props;
		const actions = [];
		const joinMeta = (model && model._joinmeta_) || {};
		const invalidModel = joinMeta.error;

		if (!invalidModel) {
			actions.push(
				<Button
					key="compose ux-item-spacing-s-left"
					className="compact"
					bsSize="large"
					onClick={this.props.onCompose}
				>
					<span>{this.intl.formatMsg('Compose into new')}</span>
				</Button>
			);
		}

		if (!model.generated && !model._supermodel && !invalidModel) {
			actions.push(
				<Button
					key="edit"
					className="compact ux-item-spacing-s-left"
					bsSize="large"
					onClick={this.props.onEdit}
				>
					<Glyphicon glyph=" gg icon-GG-pencil" />
					<span>{this.intl.formatMsg('Edit')}</span>
				</Button>
			);
		}

		const joins = joinMeta.joins || [];

		return (
			<div className="ux-container">
				<div className="model-summary">
					<ModelInfo
						modelName={model.name}
						modelConnector={model.connector && model.connector.name}
						modelDescription={model.description}
					>
						{actions}
					</ModelInfo>
				</div>
				<ModelFieldList
					model={model}
					models={models}
				/>
				{ !!joins.length && (
					<JoinsList
						joins={joins}
					/>
				)}
			</div>
		);
	}
}

ModelSummaryView.propTypes = {
	model: PropTypes.object.isRequired,
	onCompose: PropTypes.func.isRequired,
	onEdit: PropTypes.func.isRequired,

	/**
	 * Navigates to a model. Used to show parent models' details
	 */
	onViewModel: PropTypes.func.isRequired
};

export default injectIntl(ModelSummaryView);
